module.exports = __webpack_public_path__ + "static/img/A141.44e7b5ef.jpg";